module.exports = __webpack_public_path__ + "ccadcf2efd6853db5a3a8d13def1a52e.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_xlarge_x1_variable/public/news/img1.jpg
// module id = 458
// module chunks = 0